<template>
    <b-modal id="preViewModal" :title="title" size="lg">
        <div class="wrap_contents">
            <div class="img_container">
                <img :src="'/file/getImgFile/' + goodsInfo.goods_file_id" alt="">
            </div>
            <div class="table_list">
                <div class="modal_table">
                    <table class="write">
                        <colgroup>
                            <col width="100">
                            <col width="200">
                            <col width="100">
                            <col width="200">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td>{{goodsInfo.promise_goods_nm}}</td>
                                <th>출전</th>
                                <td>{{goodsInfo.promise_goods_source}}</td>
                            </tr>
                            <tr>
                                <th>상품타입</th>
                                <td>{{goodsInfo.promise_goods_type_nm}}</td>
                                <th>판매비용</th>
                                <td>{{goodsInfo.promise_goods_price}}</td>
                            </tr>
                            <tr>
                                <th>수량</th>
                                <td>{{goodsInfo.promise_goods_quantity}}</td>
                                <th>조제단휘</th>
                                <td>{{goodsInfo.prepare_unit_nm}}</td>
                            </tr>
                            <tr>
                                <th row>구성안내</th>
                                <td colspan="3">{{goodsInfo.component_descript}}</td>
                            </tr>
                            <tr>
                                <td colspan="4"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="details">
            <h2 class="page_title">상세보기</h2>
            <div class="details_box">
                <img :src="'/file/getImgFile/' + goodsInfo.goods_info_file_id" alt="">
            </div>
        </div>
        <template #modal-footer>
            <b-button class="btn"></b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'preViewModal',
        props: {
            title: String,
            goodsInfo: {},
        }
    }
</script>

<style>

</style>